module.exports = __webpack_public_path__ + "img/project.7865fb4f.png";